import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import TextInputField from "@eres/forms-web/TextInputField";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { ErrorContainer } from "@eres/forms";
import { FormContainer, IPrivateSellForm, IPrivateSellFormProps, IPrivateSellFormState, } from "./Base";
import DetailsKV from "@eres/ejari-web/component/DetailsKV";
import { checkNonEmpty } from "@eres/ejari-web/utils";


interface Props extends IPrivateSellFormProps {
	description?: string;
}

interface State extends IPrivateSellFormState {
	description?: string;
	errorContainer: ErrorContainer;
}

export default class SellerDescription extends Component<Props, State> implements IPrivateSellForm<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isValid: false,
			errorContainer: {},
			description: props.description,
		};
	}

	isValid = ( _isUserAction?: boolean ) => {
		let isValid = true;
		let errorView = this.state.errorContainer;
		isValid = checkNonEmpty( this.state, "description", errorView ) && isValid;
		this.setState( { errorContainer: errorView } );
		return isValid;
	};

	// componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
	//     const oldData = this.getData(prevState);
	//     const newData = this.getData(this.state);
	//     handleDataUpdate(oldData, newData, prevState, this);
	// }

	getData = ( state: State = this.state ) => {
		return {
			description: state?.description,
		};
	};

	render() {
		const { readonly } = this.props;
		const { errorContainer, description } = this.state;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			errorManager: defaultErrorManager,
		};
		if ( readonly ) {
			return <FormContainer title={ Strings.property_description }>
				<div className="flex-grid flex-full">
					<DetailsKV label={ Strings.property_description } value={ description }/>
				</div>
			</FormContainer>;
		}
		return (
			<FormSection title={ Strings.property_description }>
				<TextInputField
					{ ...filedProps }
					required={ true }
					id={ "description" }
					hideLabel={ true }
					label={ "" }
					customInput={ <textarea rows={ 4 } maxLength={ 1000 }/> }
					error={ errorContainer.description }/>
			</FormSection>
		);
	}
}
